export default "__VITE_ASSET__DD$9W8R3__"